import { AppError, createSystemError, isError, SystemError } from "../../core/error"
import { isErrorResponse } from "../../models/errorResponse"
import { AxiosError } from "axios"
import { tNamespace } from "../../locales/error"

export const isAxiosError = (error: unknown): error is AxiosError => {
    if (typeof error !== "object" || error === null) {
        return false
    }

    return (
        "config" in error &&
        typeof (error as AxiosError).config === "object" &&
        "isAxiosError" in error &&
        "toJSON" in error &&
        typeof (error as AxiosError).toJSON === "function"
    )
}

const KEY_TO_LOCALIZE_REGEX = /^[a-z0-9]+(-[a-z0-9]+)*$/
const getReason = (defaultReason = "", path: string): string => {
    const reasons = defaultReason.split("\n")

    const localizedReasons = reasons.map(reason => {
        const isNeedLocalization = KEY_TO_LOCALIZE_REGEX.test(reason)

        if (isNeedLocalization) {
            return `${tNamespace}${path}${reason}`
        }

        return reason
    })

    return localizedReasons.join("\n")
}

const apiCallExceptionToAppError = (error: unknown, localizeReasonPath: string): AppError => {
    if (isAxiosError(error)) {
        const errorResponse = error.response

        if (!errorResponse || !errorResponse.data) {
            return error
        }

        if (isErrorResponse(errorResponse.data)) {
            const error = errorResponse.data.error
            return {
                reason: getReason(error.message, localizeReasonPath),
                reasonKey: `${tNamespace}${error.key}`
            }
        }

        if (error.message) {
            return error.message
        }

        return JSON.stringify(errorResponse.data)
    }

    if (isError(error)) {
        return error
    }

    return JSON.stringify(error)
}

export const apiCallExceptionToSystemError = (
    messageKey: string,
    error: unknown,
    localizeReasonPath = ""
): SystemError => {
    return createSystemError(messageKey, apiCallExceptionToAppError(error, localizeReasonPath))
}
